/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useContext } from 'react';
import { ToastContext } from 'blb-contexts/Toast';
export const useToasts = () => useContext(ToastContext);